import { useEffect, useRef, useState } from "react";
import { Card, Button, Tab, Tabs, Container, Col, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import { useLoading } from "../../../../context/LoadingContext";
import { MediaPreviewer } from "../../../../components/MediaUploader";
import PrintButton from "../../../../components/PrintButton";
import { DownloadIcon } from "../../../../data/iconImage";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import html2canvas from "html2canvas";
import FileUploadsService from "../../../../services/fileupload.service";

export default function ImageViewing({ arrayImage, onClickBack, destination }) {
  const canvasRef = useRef(null);

  const { websiteName, setWebsiteName } = useWebsiteName();

  useEffect(() => {
    GetURLImage()
    // setTimeout(() => {
    // setWebsiteName("แสดงไฟล์รูปภาพ")
    // }, 300);
  }, []);

  const [objectURL, setObjectURL] = useState()
  async function GetURLImage() {
    let fileName = arrayImage?.length && (arrayImage[0]?.file_path)
    if (!fileName) return
    try {
      const file = await FileUploadsService.getFileUploads(destination, fileName)
      if (file) setObjectURL([URL.createObjectURL(file)])
    } catch (error) {
      console.log(error)
    }
  }

  const fileForPreview = arrayImage?.filter(file => file.name)
  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-center align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2">
            แสดงและพิมพ์ไฟล์รูปภาพ
          </Card.Title>

          {/* <DownloadImg data={state} /> */}
          <DownloadImg data={arrayImage} />
          <PrintButton
            componentRef={canvasRef}
            button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
          />
        </Card.Header>

        <Card.Body>

          <center style={{ margin: "auto", padding: "1em", maxHeight: "80vh" }}>
            {/* {objectURL?.map((url, ind) => (
            <Col sm={1}
              key={ind}
              className="w-auto me-2 pe-0 position-relative"
              style={{ height: "300px" }}
            >
              <Image
                className="h-100"
                src={url}
                alt={ind}
              />
            </Col>
          ))} */}
            <div id="viewImage" ref={canvasRef}
              style={{ margin: "auto", width: "fit-content" }}
            >
              {!fileForPreview?.length &&
                objectURL?.map((url, ind) => (
                  <Col sm={1}
                    key={ind}
                    className="w-auto me-2 pe-0 position-relative"
                    style={{ height: "300px" }}
                  >
                    <Image
                      className="h-100"
                      src={url}
                      alt={ind}
                    />
                  </Col>
                ))}
              <MediaPreviewer
                mediaType="Image"
                // loading={loading}
                filePreview={fileForPreview}
              />
            </div>

            <Button
              variant="outline-secondary"
              className=" mt-4  px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill "
              // onClick={() => navigate(-1)}
              onClick={() => {
                setWebsiteName("ปฏิบัติงานตาม Service Request")
                onClickBack(false)
              }}
            >
              ย้อนกลับ
            </Button>
          </center>

        </Card.Body>

      </Card>
    </>
  );
}
ImageViewing.propTypes = {
  arrayImage: PropTypes.array.isRequired,
  onClickBack: PropTypes.func,
  destination: PropTypes.string
};

const DownloadImg = ({ data, button }) => {

  async function download() {

    const element = document.getElementById("viewImage"),
      canvas = await html2canvas(element),
      url = canvas.toDataURL('image/jpg'),
      link = document.createElement('a'),
      name = data.slice(-1)[0]?.file_path || data.slice(-1)[0]?.name

    link.href = url;
    link.download = name

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Button
      variant={button?.variant || "outline-light"}
      className={
        button?.className || "px-2 rounded-circle position-absolute border-0"
      }
      style={button?.style || { zIndex: 10, top: "25px", right: "65px" }}
      onClick={download}
    >
      {button?.icon || (
        <Image
          src={DownloadIcon}
          alt="Printer Icon"
          style={{ width: "24px", height: "24px" }}
        />
      )}
      {button?.name || ""}
    </Button>
  );
};

DownloadImg.propTypes = {
  data: PropTypes.array,
  button: PropTypes.object
};